import { Environment, Stage } from './enviroment.types'

export const environment: Environment = {
    stage: Stage.Acc,
    api: {
        schema: 'https',
        host: 'ace-api.acceptance.kubernetes.pwstaging.tech',
        graphqlPath: 'graphql',
    },
    pusher: {
        app_id: '1534003',
        key: '3a0b9ab622d7dbdd12b0',
        secret: 'd5453651fb8dfe5f9dcf',
        cluster: 'eu',
    },
}
